import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "m8 .95.44.812 6.5 12 .4.738H.66l.4-.738 6.5-12L8 .95Zm5.66 12.55L8 3.05 2.34 13.5h11.32ZM7.4 10V6.5h1.2V10H7.4Zm1.35 1.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
		clipRule: "evenodd"
	})
});
export default SvgWarning;
